exports = module.exports = require("/home/kwok/projects/brewplanner/brewplanner-ui/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".bp-textfield-suggested{position:relative}.bp-textfield-suggested .bp-textfield__icon{top:-3px!important}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Commons/TextField/TextFieldSuggested/TextFieldSuggested.scss
 ** module id = 261
 ** module chunks = 0
 **/